import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Aggregation } from '@domains/metric'
import { Observable } from 'rxjs'
import { environment } from '@env'
import { ApiPlayerListMetricResult } from '@features/match-team-lineup/match-team-lineup.models'

@Injectable()
export class MatchTeamLineupApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchMetrics(
    matchId: string,
    seasonId: string,
    competitionId: string,
    aggregationDataSource: Aggregation,
  ): Observable<ApiPlayerListMetricResult> {
    return this._http.get<ApiPlayerListMetricResult>(
      environment.api.matchPlayerListMetrics(matchId, seasonId, competitionId),
      { params: { aggregationDataSource } },
    )
  }
}
